<template>
  <div
    ref="advancedBannerRef"
    class="advanced-banner"
    :class="{ 'advanced-banner--overlay': overlay }"
    :data-title="title"
    :data-sr-label="background.srLabel"
    :data-resume="resume"
    @click="pushGTM"
  >
    <!-- When link -->
    <a
      v-if="background.link && !isVideo"
      ref="background"
      :href="background.link"
      :target="background.target"
      class="advanced-banner__background"
    >
      <span class="sr-only">{{ background.srLabel }}</span>
      <div
        class="img lazyload"
        role="banner"
        :class="{ 'img--custom': image.custom }"
        :style="`${background.mobile} [(max-width: 480px)] | ${background.tablet} [(min-width: 481px) and (max-width: 1024px)] | ${background.image} [(min-width: 1025px)]`"
      />
    </a>

    <!-- When background -->
    <div
      v-if="!background.link && !isVideo"
      ref="background"
      class="advanced-banner__background"
    >
      <div
        class="img lazyload"
        role="banner"
        :aria-label="background.srLabel"
        :class="{ 'img--custom': image.custom }"
        :style="`${background.mobile} [(max-width: 480px)] | ${background.tablet} [(min-width: 481px) and (max-width: 1024px)] | ${background.image} [(min-width: 1025px)]`"
      />
    </div>

    <div
      v-if="isVideo"
      ref="background"
      class="advanced-banner__background"
    >
      <vt-video-background
        :start="isVideo && active"
        :video-url="background.image"
      />
    </div>

    <!-- Content  -->
    <div
      v-if="!background.link"
      class="advanced-banner__content"
      :class="alignment"
    >
      <slot name="button" />
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'advanced-banner',
  props: {
    background: {
      type: Object,
      default() {
        return {
          image: '/assets/niobium/Images/no-image.png',
          mobile: '/assets/niobium/Images/poster.png',
          tablet: '/assets/niobium/Images/no-image.png',
          pdfLink: false,
          link: null
        }
      }
    },
    overlay: {
      type: Boolean,
      default: true
    },
    align: {
      type: String,
      default: 'center'
    },
    title: {
      type: String,
      default: null
    },
    resume: {
      type: String,
      default: null
    },
  },
  emits: ['initbanner', 'advancedBannerRef'],
  data() {
    return {
      active: false,
      image: {
        url: "url('/assets/niobium/Images/no-image.png')",
        custom: false
      },
      desktop: false,
      language: '',
    }
  },
  computed: {
    isVideo() {
      return this.background.image && this.background.image.indexOf('.mp4') !== -1
    },
    alignment() {
      return {
        [`advanced-banner__content--${this.align}`]: this.align
      }
    },
  },
  created() {
    if (this.background.image) {
      this.image.url = `url(${this.background.image})`
    }
  },
  mounted() {
    if (this.isVideo) this.active = true

    if (!this.background.mobile) return

    this.changeimage()

    window.addEventListener('resize', this.changeimage)
    const btnPlayer = this.$el.querySelector('.advanced-banner .btn-player')
    if (btnPlayer != null) btnPlayer.addEventListener('click', this.pushButtonGTM)
    if (btnPlayer) btnPlayer.setAttribute('aria-label', this.getAriaLabel())
  },
  methods: {
    addlink() {
      if (!this.background.link || this.background.pdfLink) return

      const { background } = this.$refs

      background.setAttribute('href', this.background.link)
      background.setAttribute('target', this.background.target)
    },
    changeimage() {
      const test = window.innerWidth < 700
      const isTablet = window.innerWidth >= 481 && window.innerWidth <= 1024
      let imageUrl

      if (isTablet) {
        imageUrl = this.background.tablet || this.background.image
      } else {
        imageUrl = test ? this.background.mobile : this.background.image
      }

      if (!imageUrl) {
        imageUrl = this.background.image
      }

      const divElement = this.$refs.background

      if (divElement) {
        const mediaQuery = isTablet ? '(min-width: 481px) and (max-width: 1024px)' : ''
        const style = `
          background-image: url(${imageUrl});
          background-size: cover;
          background-repeat: no-repeat;
          ${mediaQuery ? `@media ${mediaQuery} { background-image: url(${imageUrl}); }` : ''}
        `

        divElement.setAttribute('style', style)
      }

      if (imageUrl === this.image.url) return

      this.image = {
        url: `url(${imageUrl})`,
        custom: test
      }

      this.desktop = !test
    },
    pushGTM(event) {
      event.stopPropagation()
      window.dataLayer.push({
        event: 'click',
        name: this.title || this.background.srLabel || '',
        section: 'banner',
        component_type: 'botao',
        link_url: this.background.link,
        outbound: this.isOutbound()
      })
    },
    pushButtonGTM(event) {
      event.stopPropagation()
      const title = document.querySelector('.advanced-banner .advanced-banner__title')
      window.dataLayer.push({
        event: 'click',
        name: 'play',
        section: title ? title.innerText : '',
        component_type: 'button',
        outbound: false
      })
    },
    isOutbound() {
      try {
        const bannerLink = new URL(this.background.link)
        return bannerLink.host !== window.location.host
      } catch (error) {
        return false
      }
    },
    getAriaLabel() {
      return this.language === 'pt' ? 'Reproduzir vídeo' : 'Play video'
    }
  }
}
</script>
